import React, { Component } from "react";
import FormGroup from "../FormGroup/FormGroup";
import createRef from "assets/scripts/utils/createRef";
import WithIntl from "assets/scripts/components/common/WithIntl/WithIntl";
import styles from "./SelectFormGroup.module.less";
import classNames from "classnames";
class Select extends Component {
    constructor(props, context) {
        super(props, context);
        this._handleChange = this._handleChange.bind(this);
    }
    render() {
        const { props } = this;
        return (<div className={classNames("select", { [styles.disabled]: props.attrs.disabled })}>
				<select {...props.attrs} value={props.value} onChange={this._handleChange}>
					{props.options.map(({ value, label }, index) => (<option key={index} value={value}>
							{typeof label === "string"
            ? label
            : props.intl.formatMessage(label, label.values)}
						</option>))}
				</select>
				<div className="select-decoration"/>
			</div>);
    }
    _handleChange(event) {
        this.props.onChange(event.currentTarget.value, event);
    }
}
export default class SelectFormGroup extends Component {
    constructor() {
        super(...arguments);
        this._formGroupRef = createRef();
    }
    render() {
        const { props } = this;
        const { options, ...otherProps } = props;
        return (<WithIntl>
				{intl => (<FormGroup ref={this._formGroupRef} {...otherProps}>
						{(controlState) => (<Select intl={intl} options={options} {...controlState}/>)}
					</FormGroup>)}
			</WithIntl>);
    }
    untouch() {
        if (this._formGroupRef.value != null) {
            this._formGroupRef.value.untouch();
        }
    }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/common/form/SelectFormGroup/SelectFormGroup.tsx